import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-300" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-20">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Logo dark />
          <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-sm">
            Autonoleggio di auto, furgoni e veicoli commerciali in tutta Italia.
            Noleggio Sicuro opera in collaborazione con DoYou Italy.
          </p>
        </div>
        <div className="lg:col-span-4">
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-slate-500 mb-5">Contatti diretti</p>
          <a
            href="tel:+393773899146"
            data-testid="footer-phone-link"
            className="flex items-center gap-3 font-display text-xl sm:text-2xl font-bold text-white hover:text-emerald-400 transition-colors duration-300"
          >
            <Phone className="w-5 h-5 text-emerald-400" />
            +39 377 389 9146
          </a>
          <a
            href="mailto:doyourentsita@gmail.com"
            data-testid="footer-email-link"
            className="mt-4 flex items-center gap-3 text-sm sm:text-base text-slate-300 hover:text-emerald-400 transition-colors duration-300 break-all"
          >
            <Mail className="w-5 h-5 text-emerald-400 shrink-0" />
            doyourentsita@gmail.com
          </a>
          <p className="mt-4 flex items-center gap-3 text-sm text-slate-400">
            <MapPin className="w-5 h-5 text-emerald-400 shrink-0" />
            Servizio attivo in tutta Italia
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-slate-500 mb-5">Esplora</p>
          <nav className="flex flex-col gap-3">
            {[
              ["#flotta", "La flotta"],
              ["#servizi", "I servizi"],
              ["#perche-noi", "Perché noi"],
              ["#preventivo", "Richiedi preventivo"],
            ].map(([href, label]) => (
              <a key={href} href={href} className="text-sm text-slate-400 hover:text-emerald-400 transition-colors duration-300">
                {label}
              </a>
            ))}
          </nav>
        </div>
      </div>
      <div className="mt-16 rounded-2xl border border-slate-800 bg-slate-900/60 px-6 py-5">
        <p className="text-xs text-slate-400 leading-relaxed" data-testid="footer-deposit-note">
          <span className="font-semibold text-emerald-400">Nota cauzione:</span> la cauzione va pagata al momento della conferma della prenotazione, insieme alla somma del noleggio, e verrà restituita alla riconsegna della vettura.
        </p>
      </div>
      <div className="mt-8 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © {new Date().getFullYear()} Noleggio Sicuro — in collaborazione con DoYou Italy. Tutti i diritti riservati.
        </p>
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-slate-600">
          Semplice. Sicura. Italiana.
        </p>
      </div>
    </div>
  </footer>
);
